import { jsx as _jsx } from "react/jsx-runtime";
import MuiDivider from '@mui/material/Divider';
import * as React from 'react';
export const Divider = (props) => {
    const { sx, ...muiProps } = props;
    return (_jsx(MuiDivider, { "data-role": "divider", sx: {
            width: muiProps.orientation === 'horizontal' ? '100%' : 'auto',
            height: muiProps.orientation === 'vertical' ? '100%' : 'auto',
            ...sx
        }, ...muiProps }));
};
